<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="bills"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { podStatus, paymentChinese } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_197'),
          key: 'code',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_198'),
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: i18n.t('pages_bills_index_199'),
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: i18n.t('pages_bills_index_200'),
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_201'),
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_202'),
          key: 'amount',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_203'),
          key: 'give',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_204'),
          key: 'second_card',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index({ customer_id: this.id })
  },
  computed: {
    ...mapGetters('bill', ['bills', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('bill', ['index']),
    ...mapMutations('bill', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ customer_id: this.id, page })
      this.index()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
